<template>
    <div class="pb-5">
        <top-bar activeTab="campaign"
                 :lbl="lbl"
                 :profile="profile"
                 :isLogin="isLogin"
                 :leftLogo="true"
                 @switchLang="switchLang($event)"
                 @logout="logout()"></top-bar>
        <default-layout :lbl="lbl"
                        :locale="locale"
                        :isLogin="isLogin"
                        :profile="profile"
                        :campaign="campaign"
                        v-if="isLoaded"></default-layout>
        <!-- location -->
        <div class="store-page">
            <div class="toggle-outer">
                <div class="toggle-header" @click="toggleCollapse()">
                    <h6>{{lbl.location.nearby}}</h6>
                    <div class="arrow" v-bind:class="[isOpenStoreList ? 'open' : 'closed']"></div>
                </div>
                <!-- store list -->
                <div id="store_list" v-if="isHaveStoreList" v-bind:class="[showStoreList ? 'show' : 'hide']">
                    <carousel
                        :responsive="configCarousel.responsive"
                        :dots="false"
                        :center="false"
                        :loop="false"
                        :autoWidth="true">
                        <div class="store-item"
                            v-for="(v, k) in storeList"
                            :key="k">
                            <div>
                                <img v-if="v.image_url != null" class="img-store" :src="v.image_url" />
                                <img v-else class="img-store" :src="getImageDefault()" />
                            </div>
                            <div class="text-store ellipsis-2">
                                {{ locale == 1033 ? v.name_en : v.name }}
                            </div>
                            <div class="text-km ellipsis-2">
                                {{getBranceDistance(v.distance)}} {{lbl.location.km}}
                            </div>
                            <div class="btn-store">
                                <button @click="openStoreLocationModal(k)">{{lbl.location.btnView}} <i class="arrow"></i></button>
                            </div>
                            </div>
                    </carousel>
                </div>
            </div>

            <!-- google map -->
            <div id="map">
                    <gmap-map
                        ref="map"
                        :center="center"
                        :zoom="11.8"
                        style="width:100%;  height: 500px;"
                        >
                    <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="openStoreLocationModal(index-1)"


                        :icon="getIconMarker(m.position)">
                    </gmap-marker>

                </gmap-map>

            </div>

            <StoreLocationModal view="StoreLocation"
               :busModal="busModal">
            </StoreLocationModal>

        </div>
        <menu-bar :currentTab="currentPage"></menu-bar>
        <modal view="register-main" :busModal="busModal"></modal>
    </div>
</template>
<script>
import Vue from "vue";
import Carousel from "vue-owl-carousel";

//helper
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from '@/helper/locale/locale.js';
import Location from '@/service/dior/Location.js';
import { TrackingService } from "@/helper/TrackingHelper";

import TopBar from '@/components/TopBar.vue';
import DefaultLayout from "@/components/campaign/layout/Default.vue";
import {
    CampaignConfigBuilder
} from "@/service/config/CampaignConfigModel.js";

//modal
import StoreLocationModal from '@/components/modal/StoreLocationModal.vue';
import MenuBar from "@/components/MenuBar.vue";
import Modal from "@/components/modal/Modal.vue";


export default {
    name: "StoreLocation",
    components: {
        TopBar,
        DefaultLayout,
        Carousel,
        StoreLocationModal,
        MenuBar,
        Modal,
    },
    data: function() {
        return {
            bzbConfig: Vue.bzbsConfig,
            currentPage:"store",
            isLogin: false,
            user: {},
            profile: {},
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),

            isLoaded: false,
            campaignId: '',
            campaign: null,
            campaignConfig: null,
            //store list
            isHaveStoreList: false,
            showStoreList: false,
            isOpenStoreList: false,
            storeList: [],
            configCarousel: {
                responsive: {
                    0: {
                        items: 1,
                        nav: false
                    }
                }
            },

            infoContent: '',
            infoWindowPos: {
                lat: 0,
                lng: 0
            },

            infoWinOpen: false,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            busModal: new Vue(),
            //google map
            currentLocation : { lat : 0, lng : 0},
            center: { lat: 13.7451765, lng: 100.5081332 },
            markers: [],
            places: [],
            currentPlace: null,
            tracking: new TrackingService(this)
        };
    },

    created: function() {
        console.log("ok");

        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
        });

        this.tracking.screenName('Store_location');
        this.tracking.event('Store_location', 'View_Location');
    },
    mounted() {
        setTimeout(()=> {
            this.addYourLocationButton();
        }, 1000);

        this.geolocate();
        this.initialConfig();
        this.initialStoreList();

    },

    methods: {
       toggleCollapse: function(){
            this.showStoreList = !this.showStoreList;
            this.isOpenStoreList = !this.isOpenStoreList;
            console.log("display>> "+this.showStoreList)
        },
        initialConfig: function () {
            this.campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();
        },
        getCampaign: function() {
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((result) => {
                this.campaign = result;
                this.isLoaded = true;
            }).catch((error) => {
                if (error.response) {
                    console.log(error);
                } else {
                    console.log(error);
                    this.showErrorConnectModal();
                            // this.isInternetConnected = false;
                }

            });
        },
        initialStoreList: function() {
            var strBzbsToken = Account.getToken();
            this.showLoading();
            //Get Location
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(position => {


                    var latitude = position.coords.latitude;
                    var longitude = position.coords.longitude;

                    Location.LocationNearby(strBzbsToken, latitude, longitude, this.locale, this.bzbConfig.agency_id).then((result) => {
                        this.storeList = result.data;
                        console.log("this.storeList", this.storeList)
                        this.isHaveStoreList = true;
                        this.addMarker();

                    this.hideLoading();
                    }).catch((error) => {
                        this.hideLoading();
                        console.log(error);
                        if (error.response) {
                            console.log(error);
                        } else {
                            console.log(error);
                            this.showErrorConnectModal();
                            // this.isInternetConnected = false;
                        }
                    });
                })
            }

        },
        openStoreLocationModal: function(index) {
            console.log("this.storeListIndex", this.storeList)
            var storeIndex = this.storeList[index];
            var storeName = this.locale == 1033 ? storeIndex.name_en : storeIndex.name;
            var storeAddress = this.locale == 1033 ? storeIndex.address_en : storeIndex.address;
            var storeOperation = this.locale == 1033 ? storeIndex.working_day_en : storeIndex.working_day;
            var storeContact = storeIndex.contact_number;
            var distance = storeIndex.distance;
            var image_url = storeIndex.image_url
            var configModal = {
                title: 'Dior - '+storeName,
                address: storeAddress,
                operation: storeOperation,
                phoneNumber: storeContact,
                distance: distance,
                image_url: image_url,
            };
            console.log("storeIndex", storeIndex)
            console.log(configModal)
            this.busModal.$emit("showStoreModal", configModal);
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        switchLang: function(locale) {
            Locale.setLocale(locale);
            this.lbl = Locale.getLbl();
        },
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },
        //google map
        setPlace(place) {
            this.currentPlace = place;
        },
        addMarker() {
            this.markers.push({ position: {lat: this.center.lat, lng: this.center.lng} });
            if(this.storeList.length){
                for(var i in this.storeList){
                    this.markers.push({
                        position: {
                            lat: this.storeList[i].location.latitude,
                            lng: this.storeList[i].location.longitude
                        }
                    });
                }
            }else{
                const marker = {
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng()
                };
                    this.markers.push({ position: marker });
            }

        },
        geolocate: function() {

            navigator.geolocation.getCurrentPosition(position => {
                // let latlng = new window.google.maps.LatLng(
                //     parseFloat(position.coords.latitude),
                //     parseFloat(position.coords.longitude))
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                //   this.createMarker(this.center)
            });

        },
        getBranceDistance: function (distance) {
                return (distance/1000).toFixed(1);
        },

        getIconMarker: function (item) {

            var iconMarker = "";
            if (item.lat == this.center.lat && item.lng == this.center.lng) {
                iconMarker = {url: require('../assets/img/04-store/mylocation.png'), scaledSize: {width: 40, height: 40, f: 'px', b: 'px'}}
            } else {
                iconMarker = {url: require('../assets/img/04-store/pin-logo@2x.png')}
            }


            return iconMarker;
        },
        createMarker: function (latlng) {
            this.marker = new window.google.maps.Marker({
                setMap: this.map,
                position: latlng,
                animation: window.google.maps.Animation.DROP
            })
            this.addYourLocationButton()
        },
        addYourLocationButton: function () {
            var controlDiv = document.createElement('div')

            var firstChild = document.createElement('button')
            firstChild.style.backgroundColor = '#fff'
            firstChild.style.border = 'none'
            firstChild.style.outline = 'none'
            firstChild.style.width = '28px'
            firstChild.style.height = '28px'
            firstChild.style.borderRadius = '2px'
            firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
            firstChild.style.cursor = 'pointer'
            firstChild.style.marginRight = '10px'
            firstChild.style.padding = '0px'
            firstChild.title = 'Your Location'
            controlDiv.appendChild(firstChild)

            var secondChild = document.createElement('div')
            secondChild.style.margin = '5px'
            secondChild.style.width = '18px'
            secondChild.style.height = '18px'
            secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)'
            secondChild.style.backgroundSize = '180px 18px'
            secondChild.style.backgroundPosition = '0px 0px'
            secondChild.style.backgroundRepeat = 'no-repeat'
            secondChild.id = 'you_location_img'
            firstChild.appendChild(secondChild)

            window.google.maps.event.addListener(this.$refs.map.$mapObject, 'center_changed', function () {
                secondChild.style['background-position'] = '0 0'
            })
            firstChild.addEventListener('click', ()=> {
                var imgX = '0'
                var animationInterval = setInterval( ()=> {
                    if (imgX === '-18') imgX = '0'
                    else imgX = '-18'
                    document.getElementById('you_location_img').style.backgroundPosition = '0px 0px'
                }, 500)
                if (navigator.geolocation) {

                    navigator.geolocation.getCurrentPosition((position)=> {
                        console.log(position);

                        this.$refs.map.$mapPromise.then((map) => {

                             map.panTo({lat: position.coords.latitude, lng:position.coords.longitude})
                        })

                    })
                } else {
                    clearInterval(animationInterval)
                    document.getElementById('you_location_img').style.backgroundPosition = '0px 0px'
                }
            })

            controlDiv.index = 1
            this.$refs.map.$mapObject.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv)
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },

        showErrorConnectModal: function() {

            var configModal = {

                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },

        getImageDefault: function() {
            var imgPath = `${this.bzbConfig.bzbsBlobUrl}/webconfig/dior/image/image-default.png`;
            return imgPath;
        }

    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/page/storelocation.scss";
</style>

